import React, { RefObject } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useIsVisible } from "../../../../hooks/useIsVisible/useIsVisible.hook";

const ScrollButton: React.FC<{
  reference: RefObject<HTMLElement>;
}> = ({ reference }) => {
  const isVisible = useIsVisible(reference);

  return (
    <>
      {!isVisible && (
        <button
          type="button"
          onClick={() =>
            reference.current &&
            reference.current.scrollIntoView({ behavior: "smooth" })
          }
          className="chat-scroll-fab btn btn-primary shadow-sm border-0"
          style={{
            position: "absolute",
            right: "0.5rem",
            bottom: "0.45rem",
            width: "2.5rem",
            height: "2.5rem",
            borderRadius: "50%",
            padding: 0,
            zIndex: 3,
          }}
        >
          <FontAwesomeIcon
            icon={["fas", "chevron-down"]}
            size="1x"
            className="position-relative"
          />
        </button>
      )}
    </>
  );
};

export default ScrollButton;
